import { Grid, Icon } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Autocomplete, Box, Button, EmailInput, Modal, Typography, useCommonComponentContext } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import useStrings from "../../hooks/useStrings";
import InvitationService from "../../services/identity/Invitation.service";

import { ICodename, IInput } from "../../commons/interfaces";
import { ChannelPagingType, DiscussionGroupMemberRole } from "../../constants/enums";

interface IDataModalInvitation {
    email?: IInput;
    channelId?: IInput;
    roleType?: IInput;
    communityCode?: IInput;
}

const DialogInviteMember = (props: {
    type: ChannelPagingType;
    hidenInputCommunity?: boolean;

    roleList?: ICodename[];
    listChannels?: ICodename[];
    listCommunitys?: ICodename[];

    channelId?: string;
    communityCode?: string;
}) => {
    const Strings = useStrings();

    const { clientId, tenantCode, organizationId, onError, onSuccess, onHideLoading, onShowLoading } = useCommonComponentContext();

    const [dataModal, setDataModal] = useState<IDataModalInvitation>({});
    const [openPopupInviteMember, setOpenPopupInvateMember] = useState<boolean>(false);

    const listRoleTypeCommunity: ICodename[] = useMemo(() => {
        if ([...(props.roleList || [])].length === 0) {
            return [
                { code: DiscussionGroupMemberRole.Member, name: "Member" },
                { code: DiscussionGroupMemberRole.Moderator, name: "Moderator" },
            ];
        } else {
            return [...(props.roleList || [])];
        }
    }, [props.roleList]);

    useEffect(() => {
        onShowLoading();

        let dataTemp: IDataModalInvitation = {
            email: { value: [] },
            communityCode: { value: props.communityCode },
            roleType: { value: DiscussionGroupMemberRole.Member },
            channelId: { value: props.channelId ? [props.channelId] : [] },
        };

        setDataModal(dataTemp);

        onHideLoading();
    }, [props.communityCode, props.channelId]);

    const onChangeValue = (val: any, key: string) => {
        let newdata: any = { ...dataModal };
        newdata[key] = { value: val };
        setDataModal(newdata);
    };

    const handleActionModal = async () => {
        let checked: boolean = true;
        let newdata = { ...dataModal };

        if ([...newdata?.email?.value || []].length === 0) {
            newdata["email"] = { error: Strings.Common.REQUIRED };
            checked = false;
        }

        if (props.type === ChannelPagingType.Channel) {
            if (Helpers.isNullOrEmpty(newdata?.communityCode?.value)) {
                onError(Strings.MEMBER.PLEASE_SELECT_COMMUNITY);
                checked = false;
            }
            if ([...(newdata?.channelId?.value || [])].length === 0) {
                onError(Strings.MEMBER.PLEASE_SELECT_CHANNEL);
                checked = false;
            }
        } else {
            if (Helpers.isNullOrEmpty(newdata?.communityCode?.value)) {
                if (props.hidenInputCommunity) {
                    onError(Strings.MEMBER.PLEASE_SELECT_COMMUNITY);
                } else {
                    newdata["communityCode"] = { error: Strings.Common.REQUIRED };
                }
                checked = false;
            }
        }

        if (!checked) {
            setDataModal(newdata);
        } else {
            try {
                onShowLoading();

                const dataSumit = {
                    clientId: clientId,
                    tenantCode: tenantCode,
                    organizationId: organizationId || "0",

                    emails: newdata.email?.value,
                    communities: [
                        {
                            channelIds: newdata.channelId?.value,
                            resourceCode: newdata.communityCode?.value,
                            roleType: newdata.roleType?.value || DiscussionGroupMemberRole.Member,
                        },
                    ],
                };

                const result = await InvitationService.createInvite(dataSumit);

                if (result.statusCode === 200) {
                    onSuccess(Strings.MEMBER.INVITE_MEMBER_SUCCESS);
                    setOpenPopupInvateMember(false);
                    setDataModal({});
                }
            } catch (error) {
                const e = Helpers.renderExceptionError(error);
                onError(e);
            } finally {
                onHideLoading();
            }
        }
    };

    return (
        <>
            <Box
                style={{
                    display: "flex",
                    cursor: "pointer",
                    alignItems: "center",
                }}
                onClick={() => {
                    let dataTemp: IDataModalInvitation = {
                        email: { value: [] },
                        communityCode: { value: props.communityCode },
                        roleType: { value: DiscussionGroupMemberRole.Member },
                        channelId: { value: props.channelId ? [props.channelId] : [] },
                    };

                    setDataModal(dataTemp);
                    setOpenPopupInvateMember(true);
                }}
            >
                <Icon sx={{ fontWeight: "bold", marginRight: 1 }}>add</Icon>
                <Typography variant="button" color="secondary" fontWeight="bold">
                    {Strings.MEMBER.INVITE_MEMBER}
                </Typography>
            </Box>

            <Modal
                fullWidth
                maxWidth="md"
                visible={openPopupInviteMember}
                onClose={() => {
                    setDataModal({});
                    setOpenPopupInvateMember(false);
                }}
                title={props.type === ChannelPagingType.Community ? Strings.MEMBER.INVITE_TO_COMMUNITY : Strings.MEMBER.INVITE_TO_CHANNEL}
            >
                <Box p={2}>
                    <Grid container spacing={2}>
                        {!props.hidenInputCommunity && props.type === ChannelPagingType.Community && (
                            <Grid item xs={12}>
                                <Autocomplete
                                    required
                                    data={props.listCommunitys || []}
                                    label={Strings.MEMBER.COMMUNITY_NAME}
                                    placeholder={Strings.MEMBER.SELECT_COMMUNITY}
                                    defaultValue={dataModal?.communityCode?.value}
                                    errorMessage={dataModal?.communityCode?.error}
                                    onChange={(value: any) => onChangeValue(value, "communityCode")}
                                />
                            </Grid>
                        )}
                        {props.type === ChannelPagingType.Community && (
                            <Grid item xs={12}>
                                <Autocomplete
                                    multiple
                                    data={props.listChannels || []}
                                    label={Strings.CHANNEL.CHANNEL_NAME}
                                    placeholder={Strings.CHANNEL.SELECT_CHANNEL}
                                    defaultValue={dataModal?.channelId?.value}
                                    errorMessage={dataModal?.channelId?.error}
                                    onChange={(value: any) => onChangeValue(value, "channelId")}
                                />
                            </Grid>
                        )}

                        <Grid item xs={12}>
                            <Autocomplete
                                isSelectedBox
                                label={Strings.MEMBER.ROLE_NAME}
                                data={listRoleTypeCommunity || []}
                                placeholder={Strings.MEMBER.SELECT_ROLE}
                                defaultValue={dataModal?.roleType?.value}
                                errorMessage={dataModal?.roleType?.error}
                                disabled={props.type === ChannelPagingType.Community}
                                onChange={(value: any) => onChangeValue(value, "roleType")}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <EmailInput
                                required
                                label="Email"
                                variant="standard"
                                value={dataModal?.email?.value || []}
                                errorMessage={dataModal?.email?.error}
                                placeholder={Strings.MEMBER.INPUT_EMAIL}
                                onChangeValue={(value) => {
                                    onChangeValue(value, "email");
                                }}
                            />
                        </Grid>

                        <Grid item xs={12}>
                            <Box mt={3} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <Button
                                    color={"secondary"}
                                    onClick={() => {
                                        setDataModal({});
                                        setOpenPopupInvateMember(false);
                                    }}
                                >
                                    {Strings.Common.CANCEL}
                                </Button>
                                <Button
                                    style={{ marginLeft: 12 }}
                                    color={"dark"}
                                    onClick={() => {
                                        handleActionModal();
                                    }}
                                >
                                    {Strings.Common.INVITE}
                                </Button>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </>
    );
};

export default DialogInviteMember;
